import { cloneElement, ReactElement, forwardRef } from 'react';

import useDrag from 'hooks/useDrag';

interface IDragItem {
  id: string;
  index: number;
  children: ReactElement;
  maxRange: number;
  onItemMove(startIndex: number, endIndex: number): void;
  onItemDrop(): void;
}

const DragItem = forwardRef<any, IDragItem>(
  ({ id, index, onItemMove, children, onItemDrop, maxRange }) => {
    const { isDragging, dragHandleRef, elementRef } = useDrag(
      id,
      index,
      maxRange,
      onItemMove,
      onItemDrop,
    );

    const opacity = isDragging ? 0 : 1;

    return (
      <div ref={elementRef} style={{ opacity }}>
        {cloneElement(children, { ref: dragHandleRef })}
      </div>
    );
  },
);

export default DragItem;
